import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const AddPostFetcher = (accessToken, params) => {
  return axios.post(`${apiUrlInternal}/posts`, params, addAuthToFetchOpts(accessToken, {}, 0)).then(res => res.data);
}

export const useAddPostMutation = (fetcher = AddPostFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['add-post'],
    (accessToken, params) => fetcher(accessToken, params),
    {onSuccess: () => queryClient.invalidateQueries('add-post')}
  )
}

